import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-page-job-apply',
  templateUrl: './page-job-apply.component.html',
  styleUrls: ['./page-job-apply.component.css']
})
export class PageJobApplyComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }


}
